import axios from "@/configuration/axios";
import waitFor from "@/utils/waitFor";

export default {
  strict: true,
  namespaced: true,
  state: {
    isInitialized: false,
    user: null,
    users: [],
  },
  getters: {
    isInitialized: state => state.isInitialized,
    user: state => state.user,
  },
  mutations: {
    setUser: (state, payload) => {
      state.user = payload;
      state.isInitialized = true;
    },
  },
  actions: {
    initialize: async context => {
      await waitFor(() => context.rootGetters["cognito/isInitialized"]);

      var userId = context.rootGetters["userId"];
      if (!userId) {
        context.commit("setUser", null);
        return;
      }

      await axios
        .get(`/v1/users/${userId}`)
        .then(res => context.commit("setUser", res.data))
        .catch(() => context.commit("setUser", null));
    },
  },
};
